import isEmpty from 'lodash/isEmpty';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import { GetServerSideProps } from 'next';

import { GET } from 'src/utils/service';
import { APP_URL } from 'src/constants';
import { timestamp } from 'src/utils/helper';
import { convertDatasets } from 'src/utils/datasets';
import ReactPlayer from 'react-player';

import dataDates from './api/agenad.json';
import { useEffect } from 'react';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import useUser from 'src/utils/useUser';
const PageError = dynamic(import('pages/404'));

const LayoutBCGTalk = dynamic(import('src/components/sections/section-events/bcgtalk/layout'), { ssr: true });

const BCGTalk = ({ data }: any) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (isEmpty(data)) return <PageError sessionSevId={sessionSevId} />;
  const { dataTitle, dataDate } = dataDates;
  useEffect(() => {
    document.getElementById('__next')?.classList?.remove('show-landing-page');
    document.getElementById('truehits_div')?.setAttribute('style', 'display:flex;');
  }, []);
  return (
    <>
      <NextSeo
        noindex={true}
        nofollow={true}
        title={convertDatasets(data[0], 'หัวข้อ', true) || 'เว่าถึงแก่น - The People'}
        description={convertDatasets(data[0], 'รายละเอียด', true) || 'การ "เว่า" ที่จะพาไปเข้าใจถึงแก่นอีสานในยุค 5.0 ผ่านการ "เว่าลึกถึงแก่น" (เสวนา) และ "เว่าไวถึงแก่น" (ทอล์คโชว์) '}
      />
      <Head>
        <link rel='canonical' href={`${APP_URL}/bcgtalk2022`} />
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="bcgtalk2022";
              `
          }}
        />
      </Head>
      <LayoutBCGTalk sessionSevId={sessionSevId}>
        {data.map((item: any, index: number) => {
          return (
            <SectionWrapper key={index} id={`${index + 1}`}>
              {index === 0 && (
                <div id='HOME' className='block-1'>
                  <div className='left'>
                    <div className='img-scale-animate'>
                      <img src={`${convertDatasets(item, 'โลโก้', true) || ''}`} alt={`${convertDatasets(data[0], 'หัวข้อ', true)}`} width='100%' height='100%' />
                    </div>
                  </div>
                  <div className='right'>
                    <h2>{convertDatasets(item, 'รายละเอียด', true)} </h2>
                    <p>{convertDatasets(item, 'รายละเอียด-ย่อย1', true)} </p>
                    <p>{convertDatasets(item, 'รายละเอียด-ย่อย2', true)} </p>
                  </div>
                  <div className='btn-register'>
                    <div className='btn'>
                      <a href={`${convertDatasets(item, 'ลิงค์', true) || '#'}`}>register now</a>
                    </div>
                  </div>
                </div>
              )}
              {index === 1 && (
                <div className='block-2 container'>
                  <img src={`${convertDatasets(item, 'backgroup-image', true) || ''}`} alt={`${convertDatasets(data[0], 'หัวข้อ', true)}`} width='100%' height='100%' />
                </div>
              )}
              {index === 2 && (
                <div className='block-3'>
                  <div className='left'>
                    <div className='img-scale-animate'>
                      <img src={`${convertDatasets(item, 'logo-isab-bcg-expo', true) || ''}`} alt={`${convertDatasets(data[0], 'หัวข้อ', true)}`} width='100%' height='100%' />
                    </div>
                  </div>
                  <div className='right'>
                    <h3>{convertDatasets(item, 'รายละเอียด1', true)} </h3>
                    <h3>{convertDatasets(item, 'รายละเอียด2', true)} </h3>
                  </div>
                  <div className='video'>
                    <ReactPlayer width='100%' height='100%' url={convertDatasets(item, 'วิดีโอ', true) || '#'} controls={true} />
                  </div>
                </div>
              )}
              {index === 3 && (
                <BlockWrapper id='AGENDA' className='block-4' picture={`${convertDatasets(item, 'image-background', true) || ''}`}>
                  <div className='block-4-container'>
                    <div className='left'>
                      <div className='detail-left'>
                        <h3>{convertDatasets(item, 'หัวข้อ', true)} </h3>
                        <h4>{convertDatasets(item, 'รายละเอียด-ย่อย1', true)} </h4>
                        <h4>{convertDatasets(item, 'รายละเอียด-ย่อย2', true)} </h4>
                      </div>

                      <div className='image-left'>
                        <img src={`${convertDatasets(item, 'รูป1', true) || ''}`} alt={`${convertDatasets(data[0], 'หัวข้อ', true)}`} width='100%' height='100%' />
                        <img src={`${convertDatasets(item, 'รูป2', true) || ''}`} width='100%' height='100%' />
                      </div>
                    </div>
                    <div className='right'>
                      {dataTitle.map((item, index) => (
                        <div key={index} className='data-date-list'>
                          <h4 className='title-date'>{item.title}</h4>
                          <h4>{item.desc}</h4>
                        </div>
                      ))}
                    </div>
                    <div className='detail-date'>
                      {dataDate.map((item, index) => (
                        <div className='card-item'>
                          <div className='item-title' key={index}>
                            <strong>{item.titleDate}</strong> <p>{item.descDate}</p>
                          </div>
                          <ul className='item-list' key={index}>
                            {item.dateWork.map((itemWork, indexWork) => (
                              <li key={indexWork}>
                                <p>{itemWork.datePro}</p>
                                <div className='list-title'>
                                  {itemWork.desc}
                                  {itemWork.byline.map((itemByline, indexByline) => (
                                    <p key={indexByline}>
                                      {itemByline.name}
                                      {`${itemByline.desc ? `: ${itemByline.desc}` : ''}`}
                                    </p>
                                  ))}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                    <div className='btn-register'>
                      <div className='btn'>
                        <a href={`${convertDatasets(item, 'ลิงค์', true) || '#'}`}>register now</a>
                      </div>
                    </div>
                  </div>
                </BlockWrapper>
              )}
              {index === 4 && (
                <div id='SPEAKERS' className='block-5'>
                  <div className='block-5-container'>
                    <h3>Keynote Speakers</h3>
                    <div className='card-list'>
                      {data[4].map((itemFour: any, indexFour: any) => (
                        <div className='image-speakers' key={`Speakers-${indexFour}`}>
                          <img src={itemFour.value} alt={itemFour.key} width='100%' height='100%' />
                          <p>{itemFour.key}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {index === 5 && (
                <div className='block-6'>
                  <div className='block-6-container'>
                    <h3>Moderator</h3>
                    <div className='card-list'>
                      {/* {data[5].map((itemFour: any, indexFour: any) => ( */}
                      <div className='card-item'>
                        <div className='image-moderator'>
                          <img src={`${convertDatasets(item, 'รูปภาพ', true) || ''}`} alt={`${convertDatasets(item, 'ชื่อ', true) || ''}`} width='100%' height='100%' />
                          <p className='text-name'>{convertDatasets(item, 'ชื่อ', true) || ''}</p>
                          <p>{convertDatasets(item, 'ตำแหน่ง', true) || ''}</p>
                          <p>{convertDatasets(item, 'รายละเอียด', true) || ''}</p>
                        </div>
                      </div>
                      <div className='card-item'>
                        <div className='image-moderator'>
                          <img src={`${convertDatasets(item, 'รูปภาพ-1', true) || ''}`} alt={`${convertDatasets(item, 'ชื่อ-1', true) || ''}`} width='100%' height='100%' />
                          <p className='text-name'>{convertDatasets(item, 'ชื่อ-1', true) || ''}</p>
                          <p>{convertDatasets(item, 'ตำแหน่ง-1', true) || ''}</p>
                          <p>{convertDatasets(item, 'รายละเอียด-1', true) || ''}</p>
                        </div>
                      </div>

                      {/* ))} */}
                    </div>
                  </div>
                </div>
              )}
              {index === 6 && (
                <div id='SESSIONS' className='block-7'>
                  <div className='block-7-container'>
                    <h3>Sessions</h3>
                    <div className='card-list'>
                      {data[6].map((itemSix: any, indexSix: any) => (
                        <div className='image-sessions' key={indexSix}>
                          <img src={`${itemSix.value}`} alt={`${itemSix.value || 'รูปภาพ'}`} width='100%' height='100%' />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </SectionWrapper>
          );
        })}
      </LayoutBCGTalk>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ req, res }: any) => {
  const initProps: any = {
    statusCode: 200,
    errMessage: null,
    data: [],
    topic: ''
  };

  try {
    /* --------------------------------- DATASET -------------------------------- */
    const fetchDataSet = await GET('/api/datasets?limit=30');

    const topic = 'bcgtalk';
    if (!isEmpty(fetchDataSet)) {
      const dataOpenhouse = convertDatasets(fetchDataSet?.reverse(), topic, false);
      if (!isEmpty(dataOpenhouse)) {
        initProps.data = dataOpenhouse;
        initProps.topic = topic;
      }
    }
  } catch (err: any) {
    console.error(`${timestamp()} ==========> OPEN_HOUSE ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
};

export default BCGTalk;

const BlockWrapper = styled.div<{
  picture: any;
}>`
  background: url(${props => props.picture}) fixed;
  background-repeat: no-repeat;
  background-size: cover;
  .block-4-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'left right'
      'detail-date detail-date'
      'btn btn';
    grid-gap: 20px;
    width: 1200px;
    max-width: 100%;
    margin: auto;
    padding: 60px 30px 30px;
    @media (max-width: 690px) {
      grid-template-areas:
        'left left'
        'right right'
        'detail-date detail-date'
        'btn btn';
    }
    .left {
      grid-area: left;
      .detail-left {
        h3 {
          font-size: 68px;
          color: #ffe6cd;
          @media (max-width: 690px) {
            font-size: 54px;
          }
        }
        h4 {
          font-size: 24px;
          font-weight: 300;
          @media (max-width: 690px) {
            font-size: 20px;
          }
        }
      }
      .image-left {
        display: flex;
        gap: 20px;
        padding-top: 30px;
        max-width: 100%;
        @media (max-width: 690px) {
          justify-content: center;
        }
        img {
          aspect-ratio: 1/1;
          width: 200px;
          border-radius: 30px;
          max-width: 100%;
          object-fit: cover;
          @media (max-width: 690px) {
            max-width: 100%;
            width: 160px;
          }
          &:nth-child(2) {
            margin-top: 120px;
            aspect-ratio: unset;
          }
        }
      }
    }
    .right {
      grid-area: right;
      display: flex;
      flex-direction: column;
      gap: 30px;
      .data-date-list {
        .title-date {
          color: #ffe6cd;
          font-size: 24px;
          font-weight: 600;
          @media (max-width: 768px) {
            font-size: 22px;
          }
          @media (max-width: 690px) {
            font-size: 18px;
          }
        }
        h4 {
          font-size: 22px;
          font-weight: 300;
          @media (max-width: 768px) {
            font-size: 18px;
          }
          @media (max-width: 690px) {
            font-size: 16px;
          }
        }
      }
    }
    .detail-date {
      grid-area: detail-date;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 30px;
      @media (max-width: 690px) {
        grid-template-columns: 1fr;
      }
      .item-title {
        display: flex;
        gap: 20px;
        strong {
          font-size: 5rem;
          color: #fff;
          font-weight: 600;
        }
        p {
          text-transform: capitalize;
          font-size: 30px;
          font-weight: 600;
          color: #fff;
          width: 150px;
          max-width: 100%;
        }
      }
    }
    .btn-register {
      grid-area: btn;
      display: flex;
      justify-content: center;
      .btn {
        background-color: #000;
        padding: 20px 30px;
        border-radius: 30px;
        @media (max-width: 768px) {
          padding: 10px 20px;
        }
        a {
          text-transform: uppercase;
          color: #fff;
          font-size: 18px;
          @media (max-width: 768px) {
            font-size: 16px;
          }
        }
      }
    }
    .item-list {
      border-top: 4px solid #fff;
      padding: 15px 0 0 0;
      li {
        display: flex;
        padding: 5px 0 5px 0;
        & > p {
          width: 20%;
          color: #fff;
          font-size: 14px;
          font-weight: 600;
        }
        div {
          width: 80%;
        }
        .list-title {
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          p {
            color: #fff;
            font-weight: 300;
          }
        }
      }
    }
  }
`;

const SectionWrapper: any = styled.section<{
  size: any;
  background: any;
}>`
  position: relative;
  overflow: hidden;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  .img-scale-animate {
    position: relative;
    aspect-ratio: 1/1;
    max-width: 100%;
    width: 100%;
    img {
      max-width: 100%;
      width: 100%;
    }
  }

  .block-1 {
    padding: 30px 30px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'left right'
      'btn btn';
    grid-gap: 20px;
    width: 1200px;
    max-width: 100%;
    margin: auto;
    @media (max-width: 900px) {
      grid-template-areas:
        'left left'
        'right right'
        'btn btn';
      justify-items: center;
    }
    .left {
      grid-area: left;
      width: 500px;
      max-width: 100%;
      @media (max-width: 690px) {
        width: 100%;
      }
    }
    .right {
      grid-area: right;
      margin: auto;
      display: grid;
      grid-gap: 20px;
      h2 {
        font-size: 28px;
        font-weight: 400;
        @media (max-width: 768px) {
          font-size: 22px;
        }
      }
      p {
        font-size: 24px;
        font-weight: 400;
        @media (max-width: 768px) {
          font-size: 18px;
        }
        @media (max-width: 768px) {
          font-size: 16px;
          font-weight: 300;
        }
      }
    }
    .btn-register {
      grid-area: btn;
      display: flex;
      justify-content: center;
      .btn {
        background-color: #ff8345;
        padding: 20px 30px;
        border-radius: 30px;
        @media (max-width: 768px) {
          padding: 10px 20px;
        }
        a {
          text-transform: uppercase;
          color: #fff;
          font-size: 18px;
          @media (max-width: 768px) {
            font-size: 16px;
          }
        }
      }
    }
  }
  .block-2 {
    aspect-ratio: 16/9;
    padding: 30px 0;
    width: 100%;
    max-width: 100%;
    object-fit: cover;
  }
  .block-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    grid-template-areas:
      'left right right'
      'video video video';
    width: 1200px;
    max-width: 100%;
    margin: auto;
    padding: 30px 30px;
    @media (max-width: 690px) {
      grid-template-areas:
        'left left left'
        'right right right'
        'video video video';
    }
    .left {
      grid-area: left;
      width: 250px;
      max-width: 100%;
      @media (max-width: 690px) {
        width: 200px;
        margin: auto;
      }
    }
    .right {
      grid-area: right;
      margin: auto;
      display: grid;
      grid-gap: 20px;
      h3 {
        font-size: 18px;
        font-weight: 300;
        @media (max-width: 690px) {
          font-size: 16px;
        }
      }
    }
    .video {
      grid-area: video;
      aspect-ratio: 16/9;
    }
  }

  .block-5 {
    background-color: #000;
    .block-5-container {
      width: 1200px;
      max-width: 100%;
      margin: auto;
      padding: 0 15px;
      h3 {
        font-size: 5rem;
        text-align: center;
        color: #ffe6cd;
        padding: 30px 0;

        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .image-speakers {
        aspect-ratio: 1/1;
        width: 20%;
        text-align: center;
        margin-bottom: 30px;
        padding: 10px;
        @media (max-width: 768px) {
          width: 25%;
          margin-bottom: 0px;
        }
        @media (max-width: 690px) {
          width: 50%;
          margin-bottom: 0px;
        }
        p {
          color: #ff8345;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
          @media (max-width: 690px) {
            font-size: 16px;
          }
        }
        img {
          width: 180px;
          height: 180px;
          max-width: 100%;
          object-fit: cover;
          border-radius: 50%;
          @media (max-width: 768px) {
            width: 150px;
            height: 150px;
          }
        }
      }
    }
  }
  .block-6 {
    background-color: #000;
    .block-6-container {
      width: 1200px;
      max-width: 100%;
      margin: auto;
      padding: 0 15px;
      h3 {
        font-size: 5rem;
        text-align: center;
        color: #ffe6cd;
        padding: 30px 0;
        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
    }
    .card-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .card-item {
        width: 25%;
        text-align: center;
        margin-bottom: 30px;
        aspect-ratio: 1/1;
        padding: 15px;
        @media (max-width: 768px) {
          width: 50%;
          margin-bottom: 0px;
        }
      }
      .image-moderator {
        .text-name {
          color: #ff8345 !important;
        }
        p {
          color: #fff;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          @media (max-width: 690px) {
            font-size: 16px;
          }
        }
        img {
          width: 250px;
          height: 250px;
          max-width: 100%;
          object-fit: cover;
          border-radius: 50%;
          @media (max-width: 1024px) {
            width: 180px;
            height: 180px;
          }
          @media (max-width: 768px) {
            width: 150px;
            height: 150px;
          }
        }
      }
    }
  }
  .block-7 {
    background-color: #000;
    padding: 60px 15px;
    @media (max-width: 690px) {
      padding: 30px 15px;
    }
    .block-7-container {
      width: 1200px;
      max-width: 100%;
      margin: auto;
      h3 {
        font-size: 5rem;
        text-align: center;
        color: #ffe6cd;
        padding: 30px 0;
        @media (max-width: 768px) {
          font-size: 3rem;
        }
        @media (max-width: 690px) {
          font-size: 2rem;
        }
      }
      .card-list {
        display: flex;
        flex-wrap: wrap;
        margin: -50px 0;
        @media (max-width: 1024px) {
          margin: -30px 0;
        }
        @media (max-width: 690px) {
          margin: -15px 0;
        }
        .image-sessions {
          width: 50%;
          padding: 50px;
          /* aspect-ratio: 1/1; */
          text-align: center;
          @media (max-width: 1024px) {
            padding: 30px;
          }
          @media (max-width: 690px) {
            padding: 15px;
          }
          img {
            aspect-ratio: 1/1;
            width: 100%;
            max-width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
`;
